module.exports = __webpack_public_path__ + "static/media/designer.07cde02c.svg";